<template>
    <div class="container">
        <div v-if="loadingDone">
            <div class="row page-content">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        <img src="/assets/dipocaco/pocas/sets.png" alt="gallery-poca" class="page-poca">
                        {{ $t('gallery.title') }}
                    </h1>

                    <div class="row p-0">
                        <div class="col mb-3 ps-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'en' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='en'">EN <img src="/assets/dipocaco/icons/en.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'ja' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='ja'">JA <img src="/assets/dipocaco/icons/ja.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'de' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='de'">DE <img src="/assets/dipocaco/icons/de.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3 pe-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'cn' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='cn'">CN <img src="/assets/dipocaco/icons/cn.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3 pe-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'tcgp' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='tcgp'">TCGP</a>
                        </div>
                    </div>

                    <div>
                        <template v-for="series in sortedSeriesList">
                            <div v-show="setFilter === 'tcgp' ? series.name === 'Trading Card Game Pocket' : (series.language === setFilter && series.name !== 'Trading Card Game Pocket')">
                                <div class="row px-0">
                                    <div class="col-12">
                                        <h5 class="series-name-heading float-end" :id="series.name.replaceAll(' ', '_').toLowerCase()">{{ series.name }}</h5>
                                    </div>

                                    <div class="col-12 p-0">
                                        <div class="row mb-1 p-0">
                                            <template v-for="set in series.sets">
                                                <div class="col-xxl-6 col-xl-6 col-xl-6 col-12 p-1 mb-2">
                                                    <a class="card set-banner px-4 py-3" :style="'background-image: url(/assets/dipocaco/sets/'+set.set_id+'/logo.png);'" :href="'/gallery/'+set.set_id" :id="set.set_id">
                                                        <h5 class="mt-1" :title="set.set_id">
                                                            {{ set.json.name }}<br/>
                                                            <small class="muted releasing-date">
                                                                {{ set.releaseDate.format('YYYY/MM/DD') }}
                                                                <template v-if="collectionStatus[set.set_id]">
                                                                    | <span v-if="collectionStatus[set.set_id]['is_complete'] === true"><i class="fa-solid fa-check-circle" style="color: limegreen"></i></span>
                                                                    <span v-else v-text="collectionStatus[set.set_id]['collected']+'/'+collectionStatus[set.set_id]['total']"></span>
                                                                </template>
                                                            </small>
                                                        </h5>
                                                        <div class="shop-set-image" :style="'background-image: url(/assets/dipocaco/sets/'+set.set_id+'/logo.png)'"></div>
                                                    </a>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import moment from "moment";
import axios from "axios";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import CardService from "../../CardService";

export default {
    name: "GalleryList",
    components: {CardDetailViewCanvas},
    data() {
        return {
            seriesList: {},
            sortedSeriesList: [],
            loadingDone: false,
            reversed: false,
            setFilter: 'en',
            collectionStatus: {},
        };
    },
    mounted() {
        this.$store.commit('updateUserData');

        if (localStorage.getItem('dipocaco_set_filter')) {
            this.setFilter = localStorage.getItem('dipocaco_set_filter');
        }

        setTimeout(() => {
            this.fetchSets();
            this.fetchCollectionStatus();
        }, 500);
    },
    watch: {
        setFilter(newVal, oldVal) {
            localStorage.setItem('dipocaco_set_filter', newVal)
        }
    },
    methods: {
        reverseSeriesList() {
            this.reversed = !this.reversed;
            this.sortedSeriesList = this.sortSeriesListByName(this.sortedSeriesList, this.reversed);
        },
        fetchSets() {
            axios.get('/api/all-sets').then((response) => {
                this.seriesList = response.data;

                for (let i = 0; i < Object.keys(this.seriesList).length; i++) {
                    let currentSet = Object.keys(this.seriesList)[i];
                    let seriesObject = {
                        name: currentSet,
                        sets: [],
                        language: 'en'
                    }

                    this.seriesList[Object.keys(this.seriesList)[i]].forEach((item) => {
                        seriesObject.sets.push({
                            set_id: item.set_id,
                            json: JSON.parse(item.json),
                            releaseDate: moment(JSON.parse(item.json).releaseDate),
                        });

                        if (seriesObject.language !== item.language) {
                            seriesObject.language = item.language;
                        }
                    });

                    seriesObject.sets.sort((a, b) => a.releaseDate - b.releaseDate).reverse()
                    this.sortedSeriesList.push(seriesObject);
                }

                this.sortedSeriesList = this.sortSeriesListByName(this.sortedSeriesList).reverse();
                this.loadingDone = true;
            });
        },
        sortSeriesListByName(arr, reverse = false) {
            let order = CardService.getSeriesReleaseOrder();

            if (reverse) {
                order = order.reverse();
            }

            return arr.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
        },
        fetchCollectionStatus() {
            axios.get('/api/collections/status').then(response => {
                this.collectionStatus = response.data;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.page-heading {
    background-image: url("/assets/dipocaco/pocas/gallery-poca.jpg");
    background-position: center 28%;
}

img {
    border-radius: 5px;
}

.row div {
    border: none;
    margin-bottom: 1em;
}

a {
    text-decoration: none;
}

.form-control {
    max-width: 100%;
}

.collection-card {
    margin-bottom: 1em !important;
}

.card-markers {
    font-size: 1.5em;
    font-weight: bold;
    margin-top: -1em;
    display: flex;
    position: absolute;
}

.set-logo {
    max-height: 4em;
    max-width: 100%;
}

.set-icon {
    max-height: 1.8em;
}

.list-group-item {
    vertical-align: middle;
    height: 5em;
}

.series-name-heading {
    margin-bottom: 1em;
}
</style>
